import dayjs from "dayjs";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { useAppSelector } from "../../../store/hooks";
import { vehicleHistoryKeys } from "../service/entity";
import { useMediaQuery } from "@mui/material";
export var TransactionHistoryCatalogView = function (props) {
    var _crud$vehicleHistoryK;
    var value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'TransactionHistory' : _a;
    var crud = useAppSelector(function (state) { return state.crud; });
    var currValue = value[name];
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var pagingColumns = [{
            field: 'DocName',
            headerName: 'Document no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocName ? "".concat(row === null || row === void 0 ? void 0 : row.DocName) : '-'; },
            minWidth: isDesktop ? 360 : 180
        }, {
            field: 'DocDate',
            headerName: 'Document date',
            valueFormatter: function (val, row) {
                if (row !== null && row !== void 0 && row.DocDate) {
                    var DocDate = row !== null && row !== void 0 && row.DocDate ? dayjs.utc(row === null || row === void 0 ? void 0 : row.DocDate).format('DD MMM, YYYY') : '-';
                    return DocDate;
                }
                else {
                    return '-';
                }
            },
            minWidth: isDesktop ? 350 : 180
        }, {
            field: 'CompanyName',
            headerName: 'Organization ',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CompanyName ? "".concat(row === null || row === void 0 ? void 0 : row.CompanyName) : '-'; },
            minWidth: isDesktop ? 360 : 180
        }, {
            field: 'BranchName',
            headerName: 'Branch',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.BranchName ? "".concat(row === null || row === void 0 ? void 0 : row.BranchName) : '-'; },
            minWidth: isDesktop ? 360 : 190
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Transaction details",
        isCollapsible: true,
        columns: pagingColumns,
        disableAddRow: true,
        disableDeleteRow: true
        // disableToolbarActions
        ,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true
        },
        rows: ((_crud$vehicleHistoryK = crud[vehicleHistoryKeys.SeviceHistoryKey]) === null || _crud$vehicleHistoryK === void 0 || (_crud$vehicleHistoryK = _crud$vehicleHistoryK.data) === null || _crud$vehicleHistoryK === void 0 ? void 0 : _crud$vehicleHistoryK.TransactionHistory) || [],
        error: error === null || error === void 0 ? void 0 : error[name]
    });
};
